import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpResponseStatusEnum } from '../../shared/enums/http-status-code.enum';

@Injectable({
    providedIn: 'root'
})
export class HttpResponseErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                this.logError(error.status, location.href)
                switch (error.status) {

                    case HttpResponseStatusEnum.CODE_404_NOT_FOUND:
                        this.router.navigateByUrl('/error');
                        return EMPTY;

                    case HttpResponseStatusEnum.CODE_400_BAD_REQUEST:
                    case HttpResponseStatusEnum.CODE_401_DENIED:
                    case HttpResponseStatusEnum.CODE_403_FORBIDDEN:
                    case HttpResponseStatusEnum.CODE_409_CONFLICT:
                        this.router.navigateByUrl('/error');
                        return EMPTY;

                    case HttpResponseStatusEnum.CODE_404_NOT_FOUND:
                        this.router.navigateByUrl('/error');
                        return EMPTY;

                    case HttpResponseStatusEnum.CODE_429_TOO_MANY_REQUESTS:
                    default:
                        return throwError(() => error);

                }
            }));
    }

    private logError(errorStatus: number, url: string): void {
        console.info(`INFO: HTTP-Response: ${errorStatus} on Page: ${url}`);
    }
}